import {
  WORKSPACE_SIDEBAR_BRAND_ICON_CLIP_CLASS,
  WORKSPACE_SIDEBAR_BRAND_ICON_IMG_CLASS,
  WORKSPACE_SIDEBAR_BRAND_ICON_SRC,
} from './workspace-layout';

const WorkspaceSidebarLogo = () => (
  <div className="flex shrink-0 justify-start px-[0.875rem] pb-1 pt-3">
    <div className={WORKSPACE_SIDEBAR_BRAND_ICON_CLIP_CLASS} aria-hidden>
      <img
        src={WORKSPACE_SIDEBAR_BRAND_ICON_SRC}
        alt="QTraceAi"
        className={WORKSPACE_SIDEBAR_BRAND_ICON_IMG_CLASS}
      />
    </div>
  </div>
);

export default WorkspaceSidebarLogo;
